import API from './index';
import '../helpers';


function setting(params) {
	const options = {
		method: 'POST',
		headers: {
			'auth-token': `${params.data.data.token}`
		}
	};
	const data = {
		settings: params.data.data,
	};
	return API.post('/participant/settings', data, options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}

export const settingService = {
	setting
};
